'use client';

import { Button } from '@shared/components/shadcn';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { NotificationDot } from '../../../NotificationDot/NotificationDot';

type HamburgerMenuItemProps = {
  variant: 'link' | 'button';
  icon?: React.ReactNode;
  label: string;
  link?: string;
  onMenuItemClick: () => void;
  dataTrackName: string;
  showNotification?: boolean;
  focusRef?: React.RefObject<HTMLAnchorElement | null>;
};

function HamburgerMenuItem({ variant = 'link', icon, label, link = '/', onMenuItemClick, dataTrackName, focusRef, showNotification = false }: HamburgerMenuItemProps) {
  const currentPath = usePathname();
  const isActiveLink = currentPath === link;

  const classes = {
    button: `flex flex-row justify-start items-center ${icon ? 'gap-4' : ''} px-4 py-3 w-full !rounded-md text-foreground bg-container/0 hover:bg-container/90 relative
    ${isActiveLink ? '[&_*]:text-foreground-inverse bg-container-active hover:bg-container-active/90' : ''}`,
    linkText: `text-foreground paragraph-strong`,
  };

  return (
    <Button
      asChild
      data-testid={`hamburger-menu-item-${label}`}
      variant={variant === 'link' ? 'ghost' : 'primary'}
      size="m"
      className={classes.button}
      onClick={onMenuItemClick}
      data-track-name={dataTrackName}
    >
      <Link href={link} ref={focusRef}>
        {icon}
        <span className={classes.linkText}>{label}</span>
        {showNotification && (
          <NotificationDot notificationSeverity="info" className="absolute right-4 top-1/2 -translate-y-1/2" data-testid={`hamburger-menu-item-${label}-notification-dot`} />
        )}
      </Link>
    </Button>
  );
}

export { HamburgerMenuItem, type HamburgerMenuItemProps };
